import {ZodNullable, ZodOptional, ZodTypeAny} from 'zod';

interface UnwrapZodTypeResult {
  unwrappedType: ZodTypeAny;
  isOptional: boolean;
  isNullable: boolean;
}

/**
 * Unwraps a Zod type by removing ZodOptional and ZodNullable wrappers.
 * Returns the core type along with flags indicating if it was optional or nullable.
 *
 * @param field - The Zod type to unwrap
 * @returns Object containing the unwrapped type and flags for optional/nullable status
 *
 * @example
 * const schema = z.string().optional().nullable();
 * const result = unwrapZodType(schema);
 * // result.unwrappedType is ZodString
 * // result.isOptional is true
 * // result.isNullable is true
 */
export function unwrapZodType(field: ZodTypeAny): UnwrapZodTypeResult {
  let unwrappedType = field;
  let isOptional = false;
  let isNullable = false;

  while (unwrappedType instanceof ZodOptional || unwrappedType instanceof ZodNullable) {
    if (unwrappedType instanceof ZodOptional) {
      isOptional = true;
      unwrappedType = unwrappedType.unwrap();
    } else if (unwrappedType instanceof ZodNullable) {
      isNullable = true;
      unwrappedType = unwrappedType.unwrap();
    }
  }

  return {unwrappedType, isOptional, isNullable};
}
